"use strict";
var _createClass = (function () {
  function e(e, i) {
    for (var t, n = 0; n < i.length; n++)
      ((t = i[n]).enumerable = t.enumerable || !1),
        (t.configurable = !0),
        "value" in t && (t.writable = !0),
        Object.defineProperty(e, t.key, t);
  }
  return function (i, t, n) {
    return t && e(i.prototype, t), n && e(i, n), i;
  };
})();
function _classCallCheck(e, i) {
  if (!(e instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
var HeaderEvent = (function () {
    function e(i) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.bg = this.el + "-bg"),
        (this.navBtn = this.el + "-btn"),
        (this.close = this.el + "-close"),
        (this.free = this.el + "-free"),
        (this.navArea = this.el + "-navArea"),
        (this.toggleHover = this.el + "-toggleHover"),
        (this.toggleClick = this.el + "-toggleClick"),
        (this.toggleArea = this.el + "-toggleArea"),
        (this.searchBtn = this.el + "-search"),
        (this.searchArea = this.el + "-searchArea"),
        (this.modal = ".l-modal"),
        (this.clickFlag = !0),
        this.click(),
        1024 <= $(window).innerWidth() && this.hover(),
        this.scroll();
    }
    return (
      _createClass(e, [
        {
          key: "click",
          value: function () {
            var e = this;
            $(this.toggleClick).on("click", function (i) {
              var t = $(i.currentTarget);
              t.next(e.toggleArea).is(":hidden")
                ? e.openClick(t)
                : e.closeClick(t);
            }),
              $(this.navBtn).on("click", function (i) {
                var t = $(i.currentTarget);
                return (
                  !!e.clickFlag &&
                  ((e.clickFlag = !1),
                  void (t.hasClass("is-active")
                    ? e.closeMain(e.navArea)
                    : e.openMain(e.navArea)))
                );
              }),
              $(this.close).on("click", function () {
                return (
                  !!e.clickFlag &&
                  void ($(e.navArea).hasClass("is-open")
                    ? ((e.clickFlag = !1), e.closeMain(e.navArea))
                    : (TweenMax.to(e.bg, 0.5, { alpha: 0, display: "none" }),
                      $(e.searchArea).stop().slideUp(300)))
                );
              }),
              //   1024 > $(window).innerWidth() &&
              $(this.searchBtn).on("click", function () {
                $(e.searchArea).is(":hidden")
                  ? (TweenMax.to(e.bg, 0.5, { alpha: 1, display: "block" }),
                    $(e.searchArea).stop().slideDown(300))
                  : (TweenMax.to(e.bg, 0.5, { alpha: 0, display: "none" }),
                    $(e.searchArea).stop().slideUp(300));
              });
          },
        },
        {
          key: "scroll",
          value: function () {
            var e = this,
              i = 0;
            $(this.free).length && (i = $(this.free).outerHeight()),
              $(this.el).css({ transform: "translateY(" + i + "px)" }),
              $(window).on("scroll touchmove", function () {
                var t = $(window).scrollTop();
                t > i
                  ? ($(e.el).css({ transform: "translateY(0)" }),
                    $(e.el).addClass("is-fixed"))
                  : t <= i &&
                    !$(e.navArea).hasClass("is-open") &&
                    !$(e.modal).hasClass("is-open") &&
                    ($(e.el).css({ transform: "translateY(" + i + "px)" }),
                    $(e.el).removeClass("is-fixed"));
              }),
              $(window).trigger("scroll");
          },
        },
        {
          key: "openMain",
          value: function (e) {
            var i = this,
              t = $(window).scrollTop(),
              n = new TimelineMax();
            $(this.navBtn).addClass("is-active"),
              $(e).addClass("is-open"),
              n.to(this.bg, 0.5, { alpha: 1, display: "block" }).to(
                e,
                0.5,
                {
                  alpha: 1,
                  display: "block",
                  x: 0,
                  onComplete: function () {
                    if (1024 > $(window).innerWidth()) {
                      $("body").css({
                        position: "fixed",
                        top: -t,
                        overflow: "hidden",
                      });
                      var e = $(i.el).css("transform").split(/[()]/)[1],
                        n = parseInt(e.split(",")[5]);
                      1024 > $(window).innerWidth() &&
                        0 < n &&
                        $(i.el).css({ transform: "translateY(52px)" });
                    }
                    i.clickFlag = !0;
                  },
                },
                "-=0.5"
              );
          },
        },
        {
          key: "closeMain",
          value: function (e) {
            var i = this,
              t = parseInt($("body").get(0).style.top);
            1024 > $(window).innerWidth()
              ? ($(this.el).css({ transform: "translateY(37px)" }),
                $.when(
                  $(this.navBtn).removeClass("is-active"),
                  $("body").removeAttr("style"),
                  $("html,body").animate({ scrollTop: -t }, 0).promise()
                ).done(function () {
                  i.closeAnime(e);
                }))
              : ($(this.navBtn).removeClass("is-active"), this.closeAnime(e));
          },
        },
        {
          key: "closeAnime",
          value: function (e) {
            var i = this;
            new TimelineMax()
              .to(this.bg, 0.5, { alpha: 0, display: "none" })
              .to(e, 0.5, { alpha: 0, display: "none", x: -510 }, "-=0.5")
              .to(e, 0.2, {
                scrollTo: { y: 0, autoKill: !1 },
                onComplete: function () {
                  $(e).removeClass("is-open"),
                    $(e).removeAttr("style"),
                    (i.clickFlag = !0);
                },
              });
          },
        },
        {
          key: "hover",
          value: function () {
            //     var e = this;
            //     $(this.searchBtn).on({
            //       mouseenter: function (i) {
            //         $(i.currentTarget), $(e.searchArea).stop().slideDown(300);
            //       },
            //       mouseleave: function (i) {
            //         $(i.currentTarget), $(e.searchArea).stop().slideUp(300);
            //       },
            //     }),
            //       $(this.searchArea).on({
            //         mouseenter: function (e) {
            //           $(e.currentTarget).stop().slideDown(300);
            //         },
            //         mouseleave: function (e) {
            //           $(e.currentTarget).stop().slideUp(300);
            //         },
            //       });
          },
        },
        {
          key: "openClick",
          value: function (e) {
            e.next(this.toggleArea).slideDown(300), e.addClass("is-open");
          },
        },
        {
          key: "closeClick",
          value: function (e) {
            e.next(this.toggleArea).slideUp(300), e.removeClass("is-open");
          },
        },
      ]),
      e
    );
  })(),
  InviewEvent = (function () {
    function e(i) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.eachUp = this.el + "-each"),
        (this.eachItem = this.el + "-eachItem"),
        this.event();
    }
    return (
      _createClass(e, [
        {
          key: "event",
          value: function () {
            var e = this,
              i = new IntersectionObserver(function (t) {
                var n = !0,
                  o = !1,
                  a = void 0;
                try {
                  for (
                    var s, l = t[Symbol.iterator]();
                    !(n = (s = l.next()).done);
                    n = !0
                  ) {
                    var r = s.value,
                      c = r.target;
                    r.isIntersecting &&
                      (c.classList.add("inview"),
                      c.classList.contains("js-inview-each") &&
                        e.inviewEachUp(c),
                      i.unobserve(c));
                  }
                } catch (e) {
                  (o = !0), (a = e);
                } finally {
                  try {
                    !n && l.return && l.return();
                  } finally {
                    if (o) throw a;
                  }
                }
              });
            document.querySelectorAll(".js-inview").forEach(function (e) {
              i.observe(e);
            });
          },
        },
        {
          key: "inviewEachUp",
          value: function (e) {
            $(e)
              .find(this.eachItem)
              .each(function (e, i) {
                TweenMax.to($(i), 1, { alpha: 1, delay: 0.4 * e, y: 0 });
              });
          },
        },
      ]),
      e
    );
  })(),
  ListSlider = (function () {
    function e(i) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.sp = this.el + "-sp"),
        (this.review = this.el + "-review"),
        this.event(),
        this.eventReview(),
        1024 > $(window).innerWidth() && this.eventSp();
    }
    return (
      _createClass(e, [
        {
          key: "event",
          value: function () {
            var e = this;
            $(this.el).each(function (i, t) {
              e.slider = new Swiper(t, {
                loop: !0,
                slidesPerView: "auto",
                spaceBetween: 16,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                breakpoints: { 1024: { spaceBetween: 0 } },
                pagination: { el: ".swiper-pagination" },
                speed: 1e3,
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
              });
            });
          },
        },
        {
          key: "eventSp",
          value: function () {
            var e = this;
            $(this.sp).each(function (i, t) {
              e.sliderSp = new Swiper(t, {
                loop: !0,
                loopedSlides: 2,
                slidesPerView: 1.3,
                spaceBetween: 16,
                speed: 1e3,
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
              });
            });
          },
        },
        {
          key: "eventReview",
          value: function () {
            var e = this;
            $(this.review).each(function (i, t) {
              e.sliderReview = new Swiper(t, {
                loop: !0,
                autoplay: { delay: 3e3 },
                slidesPerView: 2.3,
                spaceBetween: 16,
                breakpoints: { 1024: { slidesPerView: 4.6, spaceBetween: 30 } },
                speed: 1e3,
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
              });
            });
          },
        },
      ]),
      e
    );
  })(),
  SelectInput = (function () {
    function e(i, t) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.opt = t),
        (this.current = i + "-current"),
        (this.Click = this.el + "-click"),
        (this.ClickArea = this.el + "-clickArea"),
        this.listClick(),
        this.click(),
        this.setting();
    }
    return (
      _createClass(e, [
        {
          key: "listClick",
          value: function () {
            var e = this;
            $(this.el)
              .find("label")
              .on("click", function (i) {
                var t = $(i.currentTarget);
                t
                  .parents("li")
                  .find("label")
                  .each(function (e, i) {
                    $(i).is(":hidden") && $(i).show();
                  }),
                  e.event(t);
              });
          },
        },
        {
          key: "event",
          value: function (e) {
            var i = e.find("input").val();
            e.parents(this.el).prev(this.current).find("span").text(i),
              $(e)
                .find("input")
                .each(function (e, i) {
                  1 == $(i).prop("checked") && $(i).parents("label").hide();
                });
          },
        },
        {
          key: "setting",
          value: function () {
            var e = this;
            $(this.el).each(function (i, t) {
              var n = $(t).find("label").eq(0),
                o = n.find('input[type="radio"]'),
                a = n.parents(e.ClickArea).prev(e.Click);
              $(o).prop("checked", !0), e.event(n), e.close(a);
            });
          },
        },
        {
          key: "click",
          value: function () {
            var e = this;
            $(this.Click).on("click", function (i) {
              var t = $(i.currentTarget);
              i.stopPropagation(),
                t.next().is(":hidden") ? e.open(t) : e.close(t);
            }),
              $(this.ClickArea).on("click", function (i) {
                var t = $(i.currentTarget).prev(e.Click);
                e.close(t);
              });
          },
        },
        {
          key: "open",
          value: function (e) {
            $(this.ClickArea).slideUp(300),
              $(this.Click).removeClass("is-open"),
              e.next(this.ClickArea).slideDown(500),
              e.addClass("is-open");
          },
        },
        {
          key: "close",
          value: function (e) {
            e.removeClass("is-open"), e.next(this.ClickArea).slideUp(500);
          },
        },
      ]),
      e
    );
  })(),
  YoutubeControl = (function () {
    function e(i, t) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.fade = this.el + "-fade"),
        (this.area = this.el + "-area"),
        (this.inline = this.el + "-inline"),
        (this.modal = this.el + "-modal"),
        (this.opt = t),
        0 < $(this.inline).length &&
          (1024 > $(window).innerWidth() && !$(".beautips").length
            ? this.inlineClickSp()
            : this.inlineClickPc(),
          this.executeVideo()),
        $(".js-youtube-product").length &&
          (this.thumbVideoProduct(), this.popupVideoProduct());
    }
    return (
      _createClass(e, [
        {
          key: "inlineClickPc",
          value: function () {
            var e = this;
            $(this.inline)
              .find(this.el)
              .on("click", function (i) {
                var t = $(i.currentTarget);
                (e.flag = !1),
                  $(e.el).each(function (i, t) {
                    if ($(t).find(e.fade).is(":hidden")) {
                      e.item = $(t).find(e.fade);
                      var n = $(t).parents(e.inline).find(e.area).attr("id");
                      e.controlPauseVideo(n);
                    }
                  }),
                  setTimeout(function () {
                    (e.item = t.find(e.fade)),
                      TweenMax.to(e.item, 0.5, { alpha: 0, display: "none" });
                    var i = t.parents(e.inline).find(e.area).attr("id");
                    $(".product__media .slick-arrow").hide(),
                      $(".js-youtube-product .js-youtube-inline").removeClass(
                        "no_show"
                      ),
                      $(".slider_dots, .slick-dots").hide(),
                      $(".product__media .draggable").addClass("auto_height"),
                      e.controlPlayVideo(i);
                  }, 700);
              });
          },
        },
        {
          key: "inlineClickSp",
          value: function () {
            var e = this;
            $(this.inline)
              .find(this.el)
              .on("click", function (i) {
                var t = $(i.currentTarget);
                (e.flag = !1), (e.item = t.find(e.fade));
                var n = t.parents(e.inline).find(e.area).attr("id"),
                  o = t.parents(e.inline).find(e.modal),
                  a = new TimelineMax();
                $(o).addClass("is-open"),
                  a.to(o, 0, { display: "block" }).to(o, 0.5, { alpha: 1 });
                var s = $(window).scrollTop();
                $(".js-youtube-product").length
                  ? ((e.item = t.find(e.fade)),
                    TweenMax.to(e.item, 0.5, { alpha: 0, display: "none" }))
                  : $("body").css({
                      position: "fixed",
                      top: -s,
                      overflow: "hidden",
                    }),
                  $(".js-youtube-product .js-youtube-inline").removeClass(
                    "no_show"
                  ),
                  $(".slider_dots, .slick-dots").hide(),
                  $(".product__media .slick-arrow").hide(),
                  $(".product__media .draggable").addClass("auto_height"),
                  e.controlPlayVideo(n);
              });
          },
        },
        {
          key: "onClose",
          value: function () {
            var e = this;
            parseInt($("body").get(0).style.top),
              $(".js-youtube-product").length
                ? $.when(
                    $("body").removeAttr("style"),
                    $("html,body").animate({}, 0).promise()
                  ).done(function () {
                    TweenMax.to(e.fade, 0.5, { display: "block", alpha: 1 }),
                      TweenMax.to(e.modal, 0.5, { display: "block", alpha: 0 }),
                      $(".js-youtube-product  .js-youtube-inline").addClass(
                        "no_show"
                      ),
                      $(".close__popup__video__modal").click(),
                      $(".product__media .slick-arrow").show(),
                      $(window).width() < 767 &&
                        ($(".slider_dots").attr("data-count") > 5
                          ? $(".slider_dots").show()
                          : ($(".slick-dots").show(),
                            $(".slider_dots").hide())),
                      $(".product__media .draggable").removeClass(
                        "auto_height"
                      ),
                      $(e.modal).removeClass("is-open");
                  })
                : $.when(
                    $("body").removeAttr("style"),
                    $("html,body").animate({}, 0).promise()
                  ).done(function () {
                    TweenMax.to(e.modal, 0.5, { display: "none", alpha: 0 }),
                      $(e.modal).removeClass("is-open");
                  });
          },
        },
        {
          key: "executeVideo",
          value: function () {
            var e = this;
            "undefined" == typeof YT || void 0 === YT.Player
              ? ($.getScript("https://www.youtube.com/iframe_api"),
                (window.onYouTubePlayerAPIReady = function () {
                  e.loadPlayer();
                }))
              : this.loadPlayer();
          },
        },
        {
          key: "thumbVideoProduct",
          value: function () {
            var e = this;
            $(".slider__thumbs .slick-slide, .slider-product .slick-arrow").on(
              "click",
              function (i) {
                $(".slider-product .slick-slide").each(function () {
                  var i = $(this).find(".js-youtube-area").attr("id");
                  null != i && e.controlPauseVideo(i);
                });
              }
            );
          },
        },
        {
          key: "popupVideoProduct",
          value: function () {
            var e = this,
              i = $(".js-youtube-area_popup").attr("id");
            $(".video__popup__button").on("click", function () {
              $(".popup__video__modal").toggle(),
                $(".popupVideo__photo").trigger("click"),
                $(".popupVideo__photo").click(),
                e.controlPlayVideo(i);
            }),
              $(".close__popup__video__modal").on("click", function () {
                e.controlPauseVideo(i);
              });
          },
        },
        {
          key: "loadPlayer",
          value: function () {
            var e = this;
            function i(e) {
              var i = e.data;
              (i == YT.PlayerState.ENDED || i == YT.PlayerState.PAUSED) &&
                (1024 > $(window).innerWidth() && !$(".beautips").length
                  ? t.onClose()
                  : TweenMax.to(t.item, 0.5, {
                      alpha: 1,
                      display: "block",
                      onComplete: function () {
                        $(".js-youtube-product .js-youtube-inline").addClass(
                          "no_show"
                        ),
                          $(".product__media .slick-arrow").show(),
                          $(".product__media .draggable").removeClass(
                            "auto_height"
                          ),
                          $(window).width() < 767 &&
                            $(".slider_dots, .slick-dots").show(),
                          $(t.item).removeAttr("style");
                      },
                    }));
            }
            this.ytPlayer = {};
            var t = this;
            $(".js-youtube").each(function (t, n) {
              var o = $(n).data("id"),
                a = $(n).parents(e.inline).find(".js-youtube-area").attr("id");
              if (!o || !a || e.ytPlayer[a]) return;
              e.ytPlayer[a] = new YT.Player(a, {
                videoId: o,
                width: 890,
                height: 500,
                playerVars: {
                  rel: 0,
                  controls: 1,
                  modestbranding: 1,
                  iv_load_policy: 3,
                  loop: 0,
                  wmode: "transparent",
                  origin: location.protocol + "//" + location.hostname + "/",
                },
                events: { onStateChange: i },
              });
            });
          },
        },
        {
          key: "controlPlayVideo",
          value: function (e) {
            var i = this.ytPlayer && this.ytPlayer[e];
            i && "function" == typeof i.playVideo && i.playVideo();
          },
        },
        {
          key: "controlPauseVideo",
          value: function (e) {
            var i = this.ytPlayer && this.ytPlayer[e];
            i && "function" == typeof i.pauseVideo && i.pauseVideo();
          },
        },
      ]),
      e
    );
  })(),
  CartModal = (function () {
    function e(i, t) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.modal = this.el + "-modal"),
        (this.close = this.el + "-close"),
        (this.opt = t),
        0 < $(this.el).length && 1024 > $(window).innerWidth() && this.click();
    }
    return (
      _createClass(e, [
        {
          key: "click",
          value: function () {
            var e = this;
            $(this.el).on("click", function (i) {
              var t = $(i.currentTarget).parents("li").find(e.modal);
              new TimelineMax()
                .to(t, 0, { display: "block" })
                .to(t, 0.5, { alpha: 1 });
            }),
              $(this.close).on("click", function (i) {
                $(i.currentTarget),
                  TweenMax.to(e.modal, 0.5, { display: "none", alpha: 0 });
              });
          },
        },
      ]),
      e
    );
  })(),
  ToggleEvent = (function () {
    function e(i, t) {
      _classCallCheck(this, e),
        (this.el = i),
        (this.opt = t),
        (this.link = this.el + "Link"),
        (this.click = this.el + "Click"),
        (this.clickArea = this.el + "ClickArea"),
        this.event();
    }
    return (
      _createClass(e, [
        {
          key: "event",
          value: function () {
            var e = this;
            $(this.click).on("click", function () {
              $(e.clickArea).is(":hidden") ? e.open() : e.close();
            }),
              $(this.link).on("click", function () {
                e.open();
              });
          },
        },
        {
          key: "open",
          value: function () {
            $(this.clickArea).slideDown(300);
          },
        },
        {
          key: "close",
          value: function () {
            $(this.clickArea).slideUp(300);
          },
        },
      ]),
      e
    );
  })();
$(function () {
  window.headerEvent = new HeaderEvent(".js-header");
}),
  $(window).on("load", function () {
    new ListSlider(".js-listSlider"),
      new ToggleEvent(".js-toggle"),
      new YoutubeControl(".js-youtube"),
      new CartModal(".js-cart"),
      1024 <= $(window).innerWidth() && $("#luxy").length && luxy.init(),
      $(window).trigger("loading");
  }),
  $(window).on("loading", function () {
    new InviewEvent(".js-inview"), new SelectInput(".js-select");
  }),
  $(window).on("shopify:section:load", function () {
    new InviewEvent(".js-inview");
  });
